/** Small desktop surfaces: app connection offers, field-edit marks and
 *  pasted images. */
export default {
  connectAppTitle: "Connect {app}",
  connectAppBody: "Let Denker work with this app.",
  connect: "Connect",
  fieldCheck: "Check {name}",
  pastedImage: "Pasted Image",
  imageAddFailed: "Failed to add image to canvas",
  unknownError: "Unknown error",
  waitingForApproval: "Waiting for approval",
  uiCrashed: "React error caught — UI replaced by fallback",
} as const;
